import { render, staticRenderFns } from "./static-content-row.vue?vue&type=template&id=880563a0&scoped=true&"
import script from "./static-content-row.vue?vue&type=script&lang=js&"
export * from "./static-content-row.vue?vue&type=script&lang=js&"
import style0 from "./static-content-row.vue?vue&type=style&index=0&id=880563a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880563a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('880563a0')) {
      api.createRecord('880563a0', component.options)
    } else {
      api.reload('880563a0', component.options)
    }
    module.hot.accept("./static-content-row.vue?vue&type=template&id=880563a0&scoped=true&", function () {
      api.rerender('880563a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/static-content-row.vue"
export default component.exports